import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const COLORS = ["#152d51", "#154b51", "#8de546", "#2563EB", "#3B82F6", "#4F46E5", "#60A5FA", "#93C5FD", "#1E3A8A", "#0F172A"];

const FuelByTypeChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={250}>
    <PieChart>
      <Pie
        data={data}
        dataKey="litros"
        nameKey="tipo"
        cx="50%"
        cy="50%"
        outerRadius="60%"
        label
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  </ResponsiveContainer>
);

export default FuelByTypeChart;